/**
 *
 * Asynchronously loads the component for Logout
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
